import MyfeedInfo from "../UserProfileInfo/MyfeedInfo";
import MyPosts from "../UserProfileInfo/MyPosts";
import UserCompo from "../UserProfileInfo/UserCompo";
import SingleFeedScreen from "./SingleFeedScreen";


const FeedSinglePage = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        padding: "20px",
        height: "85vh",
        backgroundColor: "#F4F7FE",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "25%",
          textAlign: "left",
          margin: "5px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            minHeight: "80vh",
            overflowY: "scroll",
            scrollbarWidth: "none",
            scrollBehavior: "smooth",
          }}
        >
          <UserCompo />
          <MyPosts />
          <MyfeedInfo />
        </div>
      </div>

      <div
        style={{
          width: "75%",
          // height: "100vh",
          // overflowY: "sroll",
          scrollbarWidth: "none",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          // background: "#fff",
        }}
      >
        <div
          style={{
            height: "80vh",
            overflowY: "scroll",
            scrollbarWidth: "none",
          }}
        >
          <SingleFeedScreen />
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default FeedSinglePage;
